import { ChangeDetectorRef, Pipe, PipeTransform, Renderer2 } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ElementRef } from '@angular/core';
import { ToasterService } from '../../services/toaster/toaster.service';
import { AuthService } from '../../services/auth/auth.service';
import { TranslateWithKeysService } from '../../services/translate-with-keys/translate-with-keys.service';
import { ToasterTypeEnum } from '../../enums/toasterType.enum';

type Position = "top" | "bottom" | "right" | "left";

type TranslationConfig = {
	position?: Position | { [key in Position]?: number },
	offset?: number,
	readonly?: boolean,
	params?: { [key: string]: any },
	parentLvl?: number
};

@Pipe({
  name: 'translateWithKeys',
  pure: false
})

export class TranslateWithKeysPipe extends TranslatePipe implements PipeTransform {

  constructor(
		translate: TranslateService, _ref: ChangeDetectorRef,
		private el: ElementRef,
		private ren: Renderer2,
		private translateWithKeysService: TranslateWithKeysService,
		private toasterService: ToasterService,
		private authService: AuthService
	) {

		super(translate, _ref);
	}


	override transform(value: string, config: TranslationConfig = {}): any {

		const { position = 'bottom', offset = -21, readonly = false, params = null, parentLvl = 1 } = config;

			if (
				this.el.nativeElement?.parentNode &&
				!this.translateWithKeysService.isKeyAlreadyExist(value, this.el.nativeElement?.parentNode.id)) {

				let parentId = this.el.nativeElement?.parentNode?.id
				const fatherElement = this.ren.parentNode(this.el.nativeElement);

				if (!parentId) {
					parentId = 'parent-' + Date.now();
					this.ren.setProperty(fatherElement, 'id', parentId);
				}

				const rootElement = this.findParent(parentLvl);
				const tag = this.ren.createElement('div')

				this.ren.listen(tag, 'click', (e: Event) => {
					e.stopPropagation();
					navigator.clipboard.writeText(value);
					this.toasterService.show(`${value} copied`, ToasterTypeEnum.INFO);
				});

				this.ren.appendChild(tag, this.ren.createText(value))
				this.ren.addClass(tag, 'absolute');

				this.ren.setStyle(tag, 'color', 'red');
				this.ren.setStyle(tag, 'background-color', 'white');
				this.ren.setStyle(tag, 'line-height', 'normal');
				this.ren.setStyle(tag, 'font-size', '14px');
				this.ren.setStyle(tag, 'font-weight', '400');
				this.ren.setStyle(tag, 'z-index', '100');
				this.ren.setStyle(tag, 'cursor', 'pointer');
				this.ren.setStyle(tag, 'padding', '0');

				const display = this.translateWithKeysService.getKeyValue() ? 'block' : 'none'
				this.ren.setStyle(tag, 'display', display);

				if (typeof position == 'string')
					this.ren.setStyle(tag, position, offset + 'px');
				else {
					Object.keys(position).forEach(posKey => {
						this.ren.setStyle(tag, posKey, position[posKey as Position] + 'px');
					})

				}

				if (rootElement) {
					this.ren.appendChild(rootElement, tag);
					this.ren.addClass(rootElement, 'relative');

					this.translateWithKeysService.addNode({ key: value, parentId, node: tag });
				}
			}

		if (readonly) {
			return;
		}

		return super.transform(value, params)
	}

	findParent(lvl = 1) {
		let rootElement: any;
		let child = this.el.nativeElement;

		while (lvl > 0) {
			rootElement = this.ren.parentNode(child);
			child = rootElement;
			lvl--;
		}

		return rootElement
	}

}
